import { ChemistryLitElement } from '@adornis/chemistry/chemistry-tailwind-lit-element.js';
import { css } from '@adornis/chemistry/directives/css.js';
import { html, nothing } from 'lit';
import { customElement, property } from 'lit/decorators.js';
import { DateTime } from 'luxon';
/**
 * @customElement board-component-course-startdate
 */
@customElement('board-component-course-startdate')
export class BoardComponentCourseStartdate extends ChemistryLitElement {
  @property({ attribute: false }) public plannedStartdate: DateTime | undefined = undefined;
  @property({ attribute: false }) public actualStartdate: DateTime | undefined = undefined;

  override styles() {
    return [
      ...super.styles(),
      {
        ':host': {
          justifyContent: 'center',
          alignItems: 'center',
        },
      },
    ];
  }

  override render() {
    if (!this.plannedStartdate && !this.actualStartdate) {
      return nothing;
    }

    return html`<cr-flex
      h100
      horizontal
      space="sm"
      padding="sm"
      ${css({ backgroundColor: this.colors.neutral.shade(50), borderRadius: this.spacing.sm })}
    >
      ${this.plannedStartdate &&
      this.actualStartdate &&
      this.plannedStartdate.startOf('day').toMillis() === this.actualStartdate.startOf('day').toMillis()
        ? nothing
        : html` <cr-text bold>Startdatum:</cr-text>
            <cr-text ${css({ color: this._getPlannedStartDateColor() })}>
              <cr-tooltip> <cr-text> geplantes Startdatum </cr-text> </cr-tooltip>
              ${this.plannedStartdate?.toFormat('dd LLL yyyy')}
            </cr-text>`}
      ${this._showArrow()}
      <cr-text ${css({ color: this._getActualStartDateColor() })}>
        ${this.actualStartdate?.toFormat('dd LLL yyyy')}
        <cr-tooltip> <cr-text> Startdatum </cr-text> </cr-tooltip>
      </cr-text>
    </cr-flex>`;
  }

  private _getPlannedStartDateColor(): string {
    if (
      this.plannedStartdate &&
      this.actualStartdate &&
      this.plannedStartdate.startOf('day') === this.actualStartdate.startOf('day')
    )
      return this.colors.primary;
    if (this.plannedStartdate && this.plannedStartdate > DateTime.now()) return 'blue';
    if (this.plannedStartdate && this.plannedStartdate < DateTime.now()) return this.colors.tone.error;

    return 'black';
  }

  private _showArrow() {
    if (
      this.plannedStartdate &&
      this.actualStartdate &&
      this.plannedStartdate.startOf('day').toMillis() !== this.actualStartdate.startOf('day').toMillis()
    ) {
      return html` <cr-icon>arrow_forward</cr-icon> `;
    }
    return nothing;
  }

  private _getActualStartDateColor(): string {
    if (this.actualStartdate && this.actualStartdate > DateTime.now()) return 'blue';
    if (this.actualStartdate && this.actualStartdate < DateTime.now()) return this.colors.primary;
    return 'black';
  }
}
